import getDrfErrorMessage from '@/components/BranchesAndTeams/drfErrorMessage';

const DUPLICATE_NAME_PATTERN = /already exists|duplicate|unique/i;

export default function getFileManagerItemNameErrorKey(error) {
  const message = getDrfErrorMessage(error?.response);

  if (message && DUPLICATE_NAME_PATTERN.test(message)) {
    return 'duplicate_name';
  }

  return 'generic';
}
